import { render, staticRenderFns } from "./wxLanding.vue?vue&type=template&id=17a21fdc&"
import script from "./wxLanding.vue?vue&type=script&lang=js&"
export * from "./wxLanding.vue?vue&type=script&lang=js&"
import style0 from "./wxLanding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports